export default {
    appTitle: "Kuusakoski Mobisulo",

    common: {
        cancel: "Avbryt",
        close: "Stäng",
        confirm: "Bekräfta",
        next: "Nästa",
        save: "Spara",
        search: "Sök",
        send: "Skicka",
        error: "Fel",
    },

    navigation: {
        mainView: "Huvudvy",
        support: "Support",
        termsOfUse: "Användarvillkor",
        dataPrivacy: "Dataintegritet",
        account: "Konto",
        logOut: "Logga ut",
    },

    accountView: {
        email: "E-post",
    },

    addressCard: {
        accessHoursAlways: "Öppet 24h",
        navigate: "Navigera"
    },

    deviationDialog: {
        addDeviation: "Skicka rapport",
        removeTask: "Ta bort uppgift",
        deviationCategory: "Kategori",
        deviationDescription: "Innehåll",
        saveDeviation: "Spara rapport",
        plannedQuantity: "Planerad kvantitet",
        loadedQuantity: "Laddad kvantitet",
        remainingQuantity: "Kvarvarande material",
        quantityUnit: "Enhet",
        fileOptional: "Fil (valfritt)",
        waitingTime: "Väntetid",
        workTime: "Arbetstid",
        loadTransportPartsInfo: "Lägg till kostnaden för den misslyckade uppgiften i dessa fält. Var noga med att ta med dessa kostnader i den slutliga transportinformationen.",
        reportHoursInfo: "Lägg till kostnaden för timarbetet i dessa fält. Var noga med att ta med dessa kostnader i den slutliga transportinformationen."
    },

    findUnitDialog: {
        findUnit: "Hitta container",
        unitNumber: "Containernummer",
    },

    loadExecutionDialog: {
        loadExecutionInfo: "Ange transportinformation",
        comment: "Kommentar",
        commentPlaceholder: "Ange belastningsinformation här om du inte kan ange den i fälten ovan."
    },

    loadTransportPartEdit: {
        otherValue: "Övriga värden",
    },

    loadTaskSelect: {
        noLoads: "Inga laster",
        selectTask: "Välj uppgift",
        transition: "Övergång",
    },

    login: {
        authenticationResponse: {
            Error: "Ogiltig e-postadress eller lösenord",
            Unsupported: "Användaren måste logga in via Kuusakoskis www-sida"
        },

        logIn: "Logga in",
    },

    mainView: {
        incompleteTasksInstructions: "Fordonet har oavslutade uppgifter eller laster. Det valda datumet ändrades automatiskt.",
        date: "Datum",
        vehicle: "Fordon"
    },

    missingUnitDialog: {
        additionalFeatures: "Ytterligare funktioner",
        reportMissingUnit: "Rapportera saknad container",
        instructions: "En container hittades inte med containernumret du sökte efter. Rapportera en saknad container.",
        unitNumber: "Containernummer",
        unitType: "Containertyp",
        sideDoors: "Sidordörrar",
        sideRelease: "Sidspärr",
        securityChain: "Säkerhetskedja"
    },

    planTaskDialog: {
        loads: "Laster",
        task: "Uppgift",
        planTask: "Planera uppgift",
        createNewLoad: "Skapa en ny last",
        newLoad: "Ny last",
        addToLoad: "Skicka till last",
        removeFromLoad: "Ta bort från lasten",
    },

    planTaskDistanceDialog: {
        distance: "Avstånd",
        end: "Till",
        endInput: "Till (postort/postkod)",
        noResults: "Inga resultat",
        notes: "Anteckningar",
        start: "Från",
        startInput: "Från (postort/postkod)",
        title: "Sök avstånd"
    },

    planTaskLoadTransportPartsDialog: {
        transportParts: "Transportens delar",
    },

    taskStartedDialog: {
        selectTaskType: "Välj uppdragstyp",
        startTask: "Starta uppgift",
    },

    taskTransportingDialog: {
        taskTypeTitle: "Uppgiftstyp",
        leaveUnitsTitle: "Avlämnade containrar",
        noLeaveUnits: "Ingen containeravlämning.",
        takeUnitsTitle: "Upphämtade containrar",
        noTakeUnits: "Ingen containerupphämtning.",
        findUnit: "Hitta container",
        unitsMustBeProcessedBeforeAdvancing: "Containrar måste behandlas innan de går vidare till nästa fas!",
        externalUnit: "Extern container",
        confirmIgnoringUnitProcessing: "Bekräfta att containerbearbetningen ignoreras.",
    },

    taskDirection: {
        Deliver: "Leverera",
        Exchange: "Byt ut",
        Retrieve: "Hämta",
    },

    taskState: {
        New: "Ny",
        Planned: "Planerad",
        Started: "Påbörjad",
        Transporting: "Transporterar",
        Ready: "Klar",
        Deferred: "Uppskjuten",
        Canceled: "Canceled",
    },

    taskView: {
        addressFrom: "Från",
        addressTo: "Till",
        tasks: "Uppgifter",
        transportReference: "Beställningsreferens",
        noReference: "Ingen referens",
        deviations: "Rapporter",
        extraOrder: "eService-beställningar",
        attachments: "Bilagor",
        noAttachments: "Inga bilagor",
        taskStarted: "Påbörja",
        taskTransporting: "Lämnar kunden",
        taskReady: "Klar",
        executionInfo: "Transportinformation",
        waybill: "Transportdokument",
        revertTask: "Återgå till planerad",
        addDeviation: "Skicka rapport",
        removeTask: "Ta bort uppgift",
        planTask: "Planera uppgift",
        units: "Containrar",
        driversActions: "Förarens ageranden",
        taskType: "Uppgiftstyp",
        id: "Id",
        type: "Typ",
        direction: "Riktning",
        newLocation: "Ny plats",
        contactPhone: "Telefonnummer till orderansvarig",
        onsitePhone: "Telefonnummer till kontakt på plats vid hämtning",
        orderDetails: "Orderdetaljer",
    },

    termsView: {
        acceptTerms: "Acceptera användarvillkoren",
        termsAcceptedOn: "Accepterade användarvillkor",
    },

    transportPartType: {
        KM: "km",
        PCS: "st",
        TIME: "Tid",
        TN: "tn",
        TRANSITION: "Överföring"
    },

    unitSelect: {
        noUnitsAtParty: "Inga containrar på platsen.",
        showAllNUnits: "Visa samtliga {0} containrar",
    },

    validationErrors: {
        required: "Obligatorisk",
    },

    vehicleCalendar: {
        selectDate: "Välj datum"
    },

    vehicleSelectDialog: {
        selectVehicle: "Välj fordon",
        registerNumber: "Registreringsnummer",
        company: "Företag",
    },

    weekdays: {
        "0": "mån",
        "1": "tis",
        "2": "ons",
        "3": "tors",
        "4": "fre",
        "5": "lör",
        "6": "sön",
    }
};
